import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useService from "../../Hooks/useService";
import AttendanceService from "../../../Services/Attendance.service";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
const CancelMeetingButton = (props) => {
    const [cancelMeetingStatus, cancelMeeting] = useService(AttendanceService.cancelMeeting);
    const [unCancelMeetingStatus, unCancelMeeting] = useService(AttendanceService.unCancelMeeting);
    return (_jsx("div", { children: props.meetingIsCancelled ? (_jsx(SecondaryNavButton, { icon: "undo", label: "Un-Cancel Meeting", title: "Un-Cancel this  meeting", onClick: () => {
                const promise = unCancelMeeting(props.meetingId);
                if (promise) {
                    promise.then(() => props.onCancelledOrUnCancelled(false));
                }
            }, isLoading: unCancelMeetingStatus.isLoading, disabled: props.disabled })) : (_jsx(SecondaryNavButton, { icon: "calendar-times", label: "Cancel Meeting", title: "Cancel this meeting", onClick: () => {
                const _cancelMeeting = () => {
                    const promise = cancelMeeting(props.meetingId);
                    if (promise) {
                        promise.then(() => props.onCancelledOrUnCancelled(true));
                    }
                };
                if (props.confirm) {
                    // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
                    props
                        .confirm("Are you sure you want to cancel this meeting?  All attendance records for this meeting will be permanently deleted.  These records cannot be recovered.")
                        .then((confirmed) => {
                        if (confirmed) {
                            _cancelMeeting();
                        }
                    });
                }
                else {
                    _cancelMeeting();
                }
            }, isLoading: cancelMeetingStatus.isLoading, disabled: props.disabled })) }));
};
export default CancelMeetingButton;
